import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { pushToGTMDataLayer } from '../../../utils/helpers';

function Link({
	className,
	href,
	text,
	icon,
	iconPosition,
	dataMenuName,
	...otherProps
}) {
	const isButtonType = className ? className.split(' ').includes('mz-btn') : false;

	function handleTracking(e){
		if(e.target.getAttribute('data-menu-name')){
			pushToGTMDataLayer({'Menu Item': e.target.getAttribute('data-menu-name'), 'Form': e.target.getAttribute('data-form-name'), 'Dealer': e.target.getAttribute('data-form-dealer'),  'Action': e.target.getAttribute('data-form-event') });
		}
	}

	return (
		<a
			className={`mz-link ${className}`}
			href={href}
			onClick={handleTracking}
			{...otherProps}
		>
			{
				isButtonType ? (
					<Fragment>
						{icon && iconPosition === 'left' && icon}
						<span>
							{text}
						</span>
						{ icon && iconPosition === 'right' && icon}
					</Fragment>
				) : (
						text
					)
			}
		</a>
	)
}

Link.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string,
	text: PropTypes.string.isRequired,
}

Link.defaultProps = {
	className: ''
}

export default Link

